import Event from '@lib/insightsService/entities/Event';
import EventsReporter from '../EventsReporter';
class LocationEventReporter extends EventsReporter {
    sendResponseStatus(responseStatus) {
        const event = new Event('Login - Location Permission - Responded - Popup - Location Request', { responseStatus });
        this._insightsService.sendEvent(event);
    }
}
export default LocationEventReporter;
